import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import useProfileImage from 'Hooks/useProfileImage';
import Avatar from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Avatar';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import DeleteButtonWithConfirmation from 'Components/ComponentLibrary/Components/Buttons/DeleteButtonWithConfirmation';
import { getBorder } from 'Components/utils';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    width: '250px',
    height: '250px',
    marginBottom: theme.spacing(1),
    borderRadius: theme.radius.md,
    ...getBorder(theme, { all: true }),
  },
  header: {
    display: 'flex',
    justifyContent: 'start',
    marginBottom: theme.spacing(2),
  },
  content: {
    display: 'flex',
    justifyContent: 'start',
    flexGrow: 1,
    marginBottom: theme.spacing(1),
    overflowY: 'scroll',
  },
  actions: {
    display: 'flex',
    justifyContent: 'end',
  },
});

const OnboardingPlannerViewSectionNote = ({
  className,
  classes,
  profileImageLink,
  noteContent,
  onEdit,
  onDelete,
  ContentProps,
}) => {
  const {
    profileImage,
    fetchProfileImage,
  } = useProfileImage({ avatarLink: profileImageLink });

  useEffect(() => {
    fetchProfileImage();
  }, [profileImageLink]);

  return (
    <Box
      className={classNames(classes.root, className, {
      })}
    >
      <div className={classes.header}>
        {profileImage && (
          <Avatar src={profileImage || null} />
        )}
      </div>
      <div className={classes.content}>
        <RichTextDisplay
          className={classes.title}
          content={noteContent}
          {...ContentProps}
        />
      </div>
      <div className={classes.actions}>
        {onEdit && (
          <Button
            color={'primary'}
            variant={'text'}
            onClick={onEdit}
          >
                Edit
          </Button>
        )}
        {onDelete && (
          <DeleteButtonWithConfirmation
            onDelete={onDelete}
            sizeSmall
            showBackground={false}
            dialogProps={{
              title: 'Are you sure?',
              message: 'Do you want to permanently delete this note?',
              cancelLabel: 'Cancel',
              confirmLabel: 'Delete',
            }}
          />
        )}
      </div>
    </Box>
  );
};

OnboardingPlannerViewSectionNote.defaultProps = {
  className: '',
  profileImageLink: '',
  ContentProps: {},
  onEdit: null,
  onDelete: null,
};

OnboardingPlannerViewSectionNote.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  profileImageLink: PropTypes.string,
  noteContent: PropTypes.string.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  ContentProps: PropTypes.object,
};

export default withStyles(styles)(OnboardingPlannerViewSectionNote);
